import { useGetPrestationsNames } from "@ac-expo/api";
import { isBackofficePrestationType } from "@ac-expo/api-types";
import { getBuyableItemName } from "@ac-expo/utils";
import { BackofficePrestationType } from "@prisma/client";
import { useCallback, useMemo } from "react";

export const usePrestationNames = () => {
  const { data: prestations, isLoading } = useGetPrestationsNames();

  const getPrestationName = useCallback(
    (type: BackofficePrestationType): string => {
      if (!prestations || !isBackofficePrestationType(type)) {
        return getBuyableItemName({ buyableType: type });
      }

      const prestation = prestations[type];
      if (prestation?.name && prestation.name !== "") {
        return prestation.name;
      }

      return getBuyableItemName({ buyableType: type });
    },
    [prestations],
  );

  const prestationsValues = useMemo(
    () =>
      Object.values(BackofficePrestationType).map((type) => ({
        value: type,
        label: getPrestationName(type),
      })),
    [getPrestationName],
  );

  return {
    getPrestationName,
    prestationsValues,
    isLoading,
  };
};
